/**
 * ClientOnboardingSuccess Component
 * Thank you page after successful onboarding submission
 */

import React from 'react';
import styles from './ClientOnboarding.module.css';

const ClientOnboardingSuccess = () => {
    const handleClose = () => {
        window.close();
    };

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.logoHeader}>
                    <img 
                        src="/wetlab-logo.png" 
                        alt="WetLab Logo" 
                        className={styles.logoHeaderImg}
                    />
                </div>
            </div>

            <div className={styles.content}>
                <div className={styles.formContainer}>
                    <div className={styles.successContent}>
                        <div className={styles.successIcon}>✓</div>
                        <h1 className={styles.successTitle}>Thank You!</h1>
                        <p className={styles.successMessage}>
                            Your onboarding information has been submitted successfully.
                        </p>
                        <p className={styles.successDetail}>
                            Our team will review your information and contact you shortly to complete your account setup.
                        </p>
                        <div className={styles.successActions}>
                            <button 
                                onClick={handleClose}
                                className={styles.closeButton}
                            >
                                Close Window
                            </button>
                        </div>
                        <p className={styles.successFootnote}>
                            You may now safely close this window.
                        </p>
                    </div>
                </div>
            </div>

            <div className={styles.footer}>
                <p className={styles.footerText}>
                    Questions? Contact us at <a href="mailto:support@wetlab.com">support@wetlab.com</a>
                </p>
            </div>
        </div>
    );
};

export default ClientOnboardingSuccess;
